import React, { PureComponent } from 'react';
import { Checkbox } from '../../checkbox/checkbox.js';
class TableCheckbox extends PureComponent {
    constructor() {
        super(...arguments);
        this.onChange = () => {
            const { onChange } = this.props;
            onChange && onChange();
        };
    }
    render() {
        const { name = 'checkbox', value } = this.props;
        return (React.createElement(Checkbox, { label: '', name: name, onChange: this.onChange, uuid: `table-checkbox-${name}`, value: value }));
    }
}
TableCheckbox.defaultProps = {
    indeterminate: false,
    value: false,
};
export { TableCheckbox, };
//# sourceMappingURL=table-checkbox.js.map